import React from "react";
import { CalendarDays, Clock, Wallet, FileText, BarChart3, ShieldCheck, Sparkles } from "lucide-react";
import { Button } from "../components/ui/button";

const config = {
  leave: { icon: CalendarDays, title: "Leave", desc: "Request, approve and track leave balances — annual, sick and public holidays — fully aligned with the Act." },
  attendance: { icon: Clock, title: "Attendance", desc: "Capture daily and weekly working hours, overtime and rest periods for every employee." },
  payroll: { icon: Wallet, title: "Payroll", desc: "Turn wage components and hours into payslips, with night-work allowance and deductions handled." },
  documents: { icon: FileText, title: "Documents", desc: "Store contracts and statutory records in org-scoped, audit-ready file storage." },
  reports: { icon: BarChart3, title: "Reports", desc: "Headcount, leave, payroll and compliance reports — exportable for inspectors and management." },
  compliance: { icon: ShieldCheck, title: "Compliance", desc: "A live compliance dashboard mapping your records to the Employment & Labour Relations Act, 2025." },
};

export default function ComingSoon({ page }) {
  const c = config[page] || config.leave;
  const Icon = c.icon;
  return (
    <div className="pt-2 pb-6 animate-fade-up">
      <h1 className="font-display font-extrabold text-2xl sm:text-3xl text-brand-navy mb-1">{c.title}</h1>
      <p className="text-slate-500 mb-8">Part of your HR flow — coming soon.</p>
      <div className="bg-white rounded-2xl border border-slate-100 p-10 sm:p-16 text-center max-w-2xl">
        <div className="w-16 h-16 rounded-2xl bg-brand-light text-brand-blue flex items-center justify-center mx-auto mb-6"><Icon className="w-8 h-8" /></div>
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-brand-blue bg-brand-light px-3 py-1 rounded-full mb-4"><Sparkles className="w-3.5 h-3.5" /> Coming soon</span>
        <h2 className="font-display font-bold text-2xl text-brand-navy">{c.title} is on the way</h2>
        <p className="text-slate-600 mt-3 max-w-md mx-auto">{c.desc}</p>
        <Button className="mt-7 bg-brand-blue hover:bg-brand-bluedark text-white rounded-lg h-11 px-6">Notify me when it's ready</Button>
      </div>
    </div>
  );
}
